// extracted by mini-css-extract-plugin
export default {"list":"AvailableTournamentsScreen_list__wt8uo","skeletonList":"AvailableTournamentsScreen_skeletonList__O2kpC"};